export default "__VITE_ASSET__CjyepQ2p__$_?nuxt_component=async&nuxt_component_name=SvgoHomeQrcode&nuxt_component_export=default__"